import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable } from 'rxjs';

export interface EnvironmentConfig {
  chatApiUrl: string;
}
export interface OutPutItem {
  header: string;
  description: string;
  items: string[];
}
export interface ChatRecommenderState{
  hasSelections: boolean;
  hasMessages: boolean;
  isSelected:boolean;
  outPutHeader?:string;
  outPutDescription?:string;
  outPutItems?:OutPutItem[];
}

@Injectable({
  providedIn: 'root'
})
export class RecommendationServicesService extends ComponentStore<ChatRecommenderState>{
  // Default API URL if no environment service is provided
  private apiUrl = '/api';

  constructor(
    private http: HttpClient,
    @Optional() @Inject('ENVIRONMENT_CONFIG') private config: EnvironmentConfig
  ) {
    super();
    if (config && config.chatApiUrl) {
      this.apiUrl = config.chatApiUrl;
    }
  }

  init():void{
    this.setState({
      hasSelections: false,
      hasMessages: false,
      isSelected: false
    });
  }
  // API methods as shown previously
  getRecommenderTypes(): Observable<{types: string[]}> {
    return this.http.get<{types: string[]}>(`${this.apiUrl}/types`);
  }

  getRecommendations(type: string, input: any, config?: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${type}/recommend`, {
      input,
      config
    });
  }
  //Selectors
  readonly hasSelections$ = this.select(state => state.hasSelections);
  readonly hasMessages$ = this.select(state => state.hasMessages);
  readonly isSelected$ = this.select(state => state.isSelected);
  readonly outPutHeader$ = this.select(state => state.outPutHeader);
  readonly outPutDescription$ = this.select(state => state.outPutDescription);
  readonly outPutItems$ = this.select(state => state.outPutItems);
  // Updaters
  readonly hasSelections = this.updater((state:ChatRecommenderState,hasSelections:boolean) => {
    return {
      ...state,
      hasSelections:hasSelections
    }
  })
  readonly hasMessages = this.updater((state:ChatRecommenderState,hasMessages:boolean) => {
    return {
      ...state,
      hasMessages:hasMessages
    }
  })
  readonly isSelected = this.updater((state:ChatRecommenderState,isSelected:boolean) => {
    return {
      ...state,
      isSelected:isSelected
    }
  })
  readonly outPutHeader = this.updater((state:ChatRecommenderState,outPutHeader:string) => {
    return {
      ...state,
      outPutHeader:outPutHeader
    }
  })
  readonly outPutDescription = this.updater((state:ChatRecommenderState,outPutDescription:string) => {
    return {
      ...state,
      outPutDescription:outPutDescription
    }
  })
  readonly outPutItems = this.updater((state:ChatRecommenderState,outPutItems:OutPutItem[]) => {
    return {
      ...state,
      outPutItems:outPutItems
    }
  })
}
